<template>
    <div v-bind="$attrs">
        <slot :attrs="attrs" />
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    validator: Object,
});

// Provide error state to child components via Vuetify's native error handling
const attrs = computed(() => ({
    "error-messages": props.validator?.$errors?.map((e) => e.$message) || [],
    error: props.validator?.$errors?.length > 0,
}));
</script>
